import { defineComponent as _defineComponent } from 'vue'
import DomService from '@/core/dom.service';
import SearchField from '@/ui/views/search/SearchField.vue';
import { Key } from '@/core/keycodes';
import { store } from '@/store';
import { computed, ref, watch } from 'vue';
import { watchRelativeUrl } from '@/core/route.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationSearch',
  emits: ['recalculateMenuHeight'],
  setup(__props, { emit }) {


const isSearchOpen = computed<boolean>(() => store.getters['navigation/isSearchOpen']);

function closeNavigationOverlays() : void {
    store.dispatch('navigation/closeNavigationOverlays');
}

const searchField = ref<SearchField>(null);

watch(isSearchOpen, onIsSearchOpenChanged);
function onIsSearchOpenChanged(newVal): void {
    if (newVal) {
        DomService.addElementClass('html', 'search-open');
        document.addEventListener('keydown', onKeyDown);
        setTimeout(() => {
            focusInput();
            emit('recalculateMenuHeight');
        }, 10);
    } else {
        DomService.removeElementClass('html', 'search-open');
        document.removeEventListener('keydown', onKeyDown);
        setTimeout(() => {
            emit('recalculateMenuHeight');
        }, 400);
    }
}

watchRelativeUrl(onRouteChange);
function onRouteChange(route, oldRoute): void {
    if (!route || !oldRoute || route.path === oldRoute.path) {
        return;
    }
    if (isSearchOpen.value) {
        close();
    }
}

function close(): void {
    closeNavigationOverlays();
}

function focusInput(): void {
    setTimeout(() => {
        const overlay = searchField.value as SearchField;
        overlay.focus();
    }, 10);
}

function onKeyDown(event: KeyboardEvent): void {
    if (event.keyCode === Key.ESC) {
        close();
    }
}

return { __sfc: true,emit, isSearchOpen, closeNavigationOverlays, searchField, onIsSearchOpenChanged, onRouteChange, close, focusInput, onKeyDown, SearchField }
}

})